import { DateTime } from 'luxon-business-days';
import { faker } from '@faker-js/faker';

const generateQaData = () => {
  const local = DateTime.local();
  const hiredate = local.plusBusiness({ days: -90 });

  return {
    ipaddress: faker.internet.ipv4(),
    affid: '11111111',
    campaign: '',
    api_key: '',
    test: '',
    testtype: '',
    requestamount: 1000,
    ssn: faker.string.numeric(9),
    dob: '1999-05-13',
    firstname: faker.person.firstName(),
    lastname: faker.person.lastName(),
    address: faker.location.streetAddress(),
    address2: '',
    city: faker.location.city(),
    zip: '72801',
    state: 'AR',
    homephone: '(305)111-1111',
    email: `test-${faker.string.numeric(9)}@user.com`,
    dlstate: 'AR',
    dlnumber: '11111111111',
    ismilitary: 'false',
    iscitizen: 'true',
    otheroffers: 'false',
    rentorown: 'O',
    addressmonths: 0,
    addressyears: 5,
    incometype: 'E',
    paytype: 'D',
    hiredate: hiredate.toFormat('yyyy-MM-dd'),
    empmonths: '8',
    empyears: '6',
    empname: faker.company.name(),
    empphone: '(222)222-2222',
    empphoneext: '',
    payfrequency: 'W',
    netmonthly: '3500',
    grossmonthly: '3500',
    bankname: faker.company.name(),
    accounttype: 'C',
    routingnumber: '256074974',
    accountnumber: faker.finance.accountNumber(),
    bankmonths: '0',
    bankyears: '4',
    lastpaydate: '',
    nextpaydate: '',
    secondpaydate: '',
    customer_guid: null,
    return_customer: 0,
    prescreen_campaign_id: '',

    clarityResponse: {
      prescreen: {
        result: 'pass',
        message: 'Testing prescreen',
      },
      prescreen_log: {
        result: 'pass',
        message: 'Testing prescreen_log',
      },
      logFraud: {
        result: 'pass',
        message: 'Testing logFraud',
      },
      fraud: {
        result: 'pass',
        message: 'Testing fraud',
      },
      logFraudInsight: {
        result: 'pass',
        message: 'Testing logFraudInsight',
      },
      fraudInsight: {
        result: 'pass',
        message: 'Testing fraudInsight',
      },
      logBureauLite: {
        result: 'pass',
        message: 'Testing logBureauLite',
      },
      bureauLite: {
        result: 'pass',
        message: 'Testing bureauLite',
      },
      risk: {
        result: 'pass',
        message: 'Testing risk',
      },
      logRisk: {
        result: 'pass',
        message: 'Testing logRisk',
      },
      bank: {
        result: 'pass',
        message: 'Testing bank',
      },
      logBank: {
        result: 'pass',
        message: 'Testing logBank',
      },
    },

    validifiResponse: {
      Response: {
        Requests: {
          Request: {
            Packages: {
              Package: {
                Scorings: {
                  Scoring: {
                    Score: '115',
                  },
                },
              },
            },
          },
        },
      },
    },
    whitepagesResponse: {
      primary_email_address_checks: {
        is_valid: true,
      },
      primary_phone_checks: {
        is_valid: true,
      },
      primary_address_checks: {
        is_valid: true,
        type: 'Single unit',
        is_commercial: 0,
      },
      identity_check_score: '115',
      ip_address_checks: {
        is_valid: true,
        geolocation: {
          country_code: 'US',
        },
      },
      identity_network_score: '115',
    },
    sentilinkResponse: {
      address_is_cmra: 0,
      address_is_commercial: 0,
    },
  };
};

export default generateQaData();

export { generateQaData }; // Export the function for use in other modules
